export default __webpack_public_path__ + "static/media/liblary.decc138a.png";